export const removeCurrencyFormat = (currency: string) => {
  return Number(currency.replaceAll(',', ''));
};
